/**
 * Keep the Prestige header cart indicator aligned with the Rebuy Smart Cart state
 * and preserve market-aware checkout routing.
 */
(function () {
  var wheelSyncTimer = null;
  var wheelSyncInFlight = false;

  function scheduleWheelCampaignQuantitySync(delay) {
    window.clearTimeout(wheelSyncTimer);
    wheelSyncTimer = window.setTimeout(syncWheelCampaignQuantities, delay || 650);
  }

  async function syncWheelCampaignQuantities() {
    if (wheelSyncInFlight) {
      scheduleWheelCampaignQuantitySync(250);
      return true;
    }
    wheelSyncInFlight = true;

    try {
      var response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) return false;

      var cart = await response.json();
      var parents = {};
      var mismatchedChildren = [];

      cart.items.forEach(function (line, index) {
        var properties = line.properties || {};
        var bundleId = properties._wheel_bundle_id;
        if (properties._wheel_bundle_role === 'case' && typeof bundleId === 'string' && bundleId.indexOf('wheel-') === 0) {
          parents[bundleId] = line;
        }
      });

      cart.items.forEach(function (line, index) {
        var properties = line.properties || {};
        var bundleId = properties._wheel_bundle_id;
        if (properties._wheel_bundle_role !== 'wheels' || typeof bundleId !== 'string' || bundleId.indexOf('wheel-') !== 0) return;

        var parent = parents[bundleId];
        var requiredQuantity = parent ? parent.quantity : 0;
        if (line.quantity !== requiredQuantity) {
          mismatchedChildren.push({ line: index + 1, quantity: requiredQuantity });
        }
      });

      if (!mismatchedChildren.length) return false;

      var updatedCart = cart;
      for (var i = mismatchedChildren.length - 1; i >= 0; i -= 1) {
        var updateResponse = await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(mismatchedChildren[i])
        });
        if (!updateResponse.ok) return false;
        updatedCart = await updateResponse.json();
      }
      document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: updatedCart } }));

      if (/\/cart\/?$/.test(window.location.pathname)) {
        window.location.reload();
      }
      return true;
    } catch (error) {
      return false;
    } finally {
      wheelSyncInFlight = false;
    }
  }

  document.addEventListener('click', function (event) {
    var campaignButton = event.target && event.target.closest
      ? event.target.closest('[data-wheel-campaign-quantity]')
      : null;
    if (campaignButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      campaignButton.disabled = true;

      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: Number(campaignButton.dataset.line),
          quantity: Math.max(0, Number(campaignButton.dataset.quantity))
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to update Wheel Campaign quantity');
        return response.json();
      }).then(function () {
        return syncWheelCampaignQuantities();
      }).then(function (synchronized) {
        if (!synchronized && /\/cart\/?$/.test(window.location.pathname)) window.location.reload();
      }).catch(function () {
        campaignButton.disabled = false;
      });
      return;
    }

    var target = event.target && event.target.closest
      ? event.target.closest('#rebuy-cart button, line-item-quantity a, line-item-quantity button')
      : null;
    if (target) scheduleWheelCampaignQuantitySync(800);
  }, true);

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('#rebuy-cart, line-item-quantity')) {
      scheduleWheelCampaignQuantitySync(500);
    }
  }, true);

  document.addEventListener('rebuy:smartcart.show', function () {
    scheduleWheelCampaignQuantitySync(250);
  });

  window.addEventListener('pageshow', function () {
    scheduleWheelCampaignQuantitySync(250);
  });

  document.addEventListener('rebuy:smartcart.hide', function (event) {
    var smartCart = event.detail && event.detail.smartcart;

    if (!smartCart || typeof smartCart.hasItems !== 'function') return;

    if (!smartCart.hasItems()) {
      var cartDot = document.querySelector('.header__cart-dot');
      if (cartDot) cartDot.classList.remove('is-visible');
    }
  });

  document.body.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest
      ? target.closest('.rebuy-cart__checkout-button[data-role="localized-checkout"]')
      : null;

    if (!button || button.hasAttribute('disabled')) return;

    var marketMatch = window.location.pathname.toLowerCase().match(/^\/([a-z]{2}|[a-z]{2}-[a-z]{2})(?:\/|$)/);
    var marketPrefix = marketMatch ? '/' + marketMatch[1] + '/' : '/';

    window.location.assign(marketPrefix + 'checkout');
  });
})();
